export const ONBOARDING_STEPS = {
  PLATFORM: 0,
  STREAMING_EXPERIENCE: 1,
  OVERLAY_EXPERIENCE: 2,
  STREAMING_SOFTWARE: 3,
  TECH_COMFORT: 4,
  CONTENT_TYPE: 5,
  AUDIENCE_SIZE: 6,
  LANGUAGE: 7,
  INTERESTED_OVERLAYS: 8,
  MAIN_GOAL: 9,
  BUDGET: 10,
  HOW_DID_YOU_HEAR: 11,
  SUGGESTIONS: 12
};

export const TOTAL_STEPS = 13;

export const ONBOARDING_OPTIONS = {
  platform: [
    { value: 'twitch', labelKey: 'onboarding.platform.twitch' },
    { value: 'youtube', labelKey: 'onboarding.platform.youtube' },
    { value: 'kick', labelKey: 'onboarding.platform.kick' },
    { value: 'facebook', labelKey: 'onboarding.platform.facebook' },
    { value: 'tiktok', labelKey: 'onboarding.platform.tiktok' },
    { value: 'other', labelKey: 'onboarding.platform.other' }
  ],
  
  streamingExperience: [
    { value: 'new', labelKey: 'onboarding.streamingExperience.new' },
    { value: '1-6months', labelKey: 'onboarding.streamingExperience.1-6months' },
    { value: '6-12months', labelKey: 'onboarding.streamingExperience.6-12months' },
    { value: '1-2years', labelKey: 'onboarding.streamingExperience.1-2years' },
    { value: '2plus', labelKey: 'onboarding.streamingExperience.2plus' }
  ],
  
  overlayExperience: [
    { value: 'never', labelKey: 'onboarding.overlayExperience.never' },
    { value: 'few', labelKey: 'onboarding.overlayExperience.few' },
    { value: 'regular', labelKey: 'onboarding.overlayExperience.regular' },
    { value: 'expert', labelKey: 'onboarding.overlayExperience.expert' }
  ],
  
  streamingSoftware: [
    { value: 'obs', labelKey: 'onboarding.streamingSoftware.obs' },
    { value: 'streamlabs', labelKey: 'onboarding.streamingSoftware.streamlabs' },
    { value: 'xsplit', labelKey: 'onboarding.streamingSoftware.xsplit' },
    { value: 'restream', labelKey: 'onboarding.streamingSoftware.restream' },
    { value: 'other', labelKey: 'onboarding.streamingSoftware.other' }
  ],
  
  techComfort: [
    { value: 'beginner', labelKey: 'onboarding.techComfort.beginner' },
    { value: 'intermediate', labelKey: 'onboarding.techComfort.intermediate' },
    { value: 'advanced', labelKey: 'onboarding.techComfort.advanced' }
  ],
  
  contentType: [
    { value: 'gaming', labelKey: 'onboarding.contentType.gaming' },
    { value: 'justchatting', labelKey: 'onboarding.contentType.justchatting' },
    { value: 'sports', labelKey: 'onboarding.contentType.sports' },
    { value: 'music', labelKey: 'onboarding.contentType.music' },
    { value: 'art', labelKey: 'onboarding.contentType.art' },
    { value: 'education', labelKey: 'onboarding.contentType.education' },
    { value: 'variety', labelKey: 'onboarding.contentType.variety' }
  ],
  
  audienceSize: [
    { value: 'under50', labelKey: 'onboarding.audienceSize.under50' },
    { value: '50-200', labelKey: 'onboarding.audienceSize.50-200' },
    { value: '200-1000', labelKey: 'onboarding.audienceSize.200-1000' },
    { value: '1000-5000', labelKey: 'onboarding.audienceSize.1000-5000' },
    { value: '5000plus', labelKey: 'onboarding.audienceSize.5000plus' }
  ],
  
  language: [
    { value: 'spanish', labelKey: 'onboarding.language.spanish' },
    { value: 'english', labelKey: 'onboarding.language.english' },
    { value: 'portuguese', labelKey: 'onboarding.language.portuguese' },
    { value: 'french', labelKey: 'onboarding.language.french' },
    { value: 'other', labelKey: 'onboarding.language.other' }
  ],
  
  interestedOverlays: [
    { value: 'countdown', labelKey: 'menu.countdown' },
    { value: 'sports', labelKey: 'menu.categories.scoreboards' },
    { value: 'alertbox', labelKey: 'menu.alertbox' },
    { value: 'chat', labelKey: 'menu.chat' },
    { value: 'giveaway', labelKey: 'menu.giveaway' },
    { value: 'quiz', labelKey: 'menu.quiz' },
    { value: 'roulette', labelKey: 'menu.roulette' },
    { value: 'confetti', labelKey: 'menu.confetti' },
    { value: 'controller', labelKey: 'menu.controller' },
    { value: 'medialooper', labelKey: 'menu.medialoop' }
  ],
  
  mainGoal: [
    { value: 'professional', labelKey: 'onboarding.mainGoal.professional' },
    { value: 'interaction', labelKey: 'onboarding.mainGoal.interaction' },
    { value: 'unique', labelKey: 'onboarding.mainGoal.unique' },
    { value: 'monetize', labelKey: 'onboarding.mainGoal.monetize' },
    { value: 'fun', labelKey: 'onboarding.mainGoal.fun' }
  ],
  
  budget: [
    { value: 'under10', labelKey: 'onboarding.budget.under10' },
    { value: '10-25', labelKey: 'onboarding.budget.10-25' },
    { value: '25-50', labelKey: 'onboarding.budget.25-50' },
    { value: '50-100', labelKey: 'onboarding.budget.50-100' },
    { value: '100plus', labelKey: 'onboarding.budget.100plus' }
  ],
  
  howDidYouHear: [
    { value: 'social', labelKey: 'onboarding.howDidYouHear.social' },
    { value: 'recommendation', labelKey: 'onboarding.howDidYouHear.recommendation' },
    { value: 'google', labelKey: 'onboarding.howDidYouHear.google' },
    { value: 'youtube', labelKey: 'onboarding.howDidYouHear.youtube' },
    { value: 'twitch', labelKey: 'onboarding.howDidYouHear.twitch' },
    { value: 'other', labelKey: 'onboarding.howDidYouHear.other' }
  ]
};

export const ONBOARDING_QUESTIONS = {
  [ONBOARDING_STEPS.PLATFORM]: {
    titleKey: 'onboarding.questions.platform.title',
    subtitleKey: 'onboarding.questions.platform.subtitle',
    type: 'single-select',
    field: 'platform',
    options: ONBOARDING_OPTIONS.platform
  },
  
  [ONBOARDING_STEPS.STREAMING_EXPERIENCE]: {
    titleKey: 'onboarding.questions.streamingExperience.title',
    subtitleKey: 'onboarding.questions.streamingExperience.subtitle',
    type: 'single-select',
    field: 'streamingExperience',
    options: ONBOARDING_OPTIONS.streamingExperience
  },
  
  [ONBOARDING_STEPS.OVERLAY_EXPERIENCE]: {
    titleKey: 'onboarding.questions.overlayExperience.title',
    subtitleKey: 'onboarding.questions.overlayExperience.subtitle',
    type: 'single-select',
    field: 'overlayExperience',
    options: ONBOARDING_OPTIONS.overlayExperience
  },
  
  [ONBOARDING_STEPS.STREAMING_SOFTWARE]: {
    titleKey: 'onboarding.questions.streamingSoftware.title',
    subtitleKey: 'onboarding.questions.streamingSoftware.subtitle',
    type: 'single-select',
    field: 'streamingSoftware',
    options: ONBOARDING_OPTIONS.streamingSoftware
  },
  
  [ONBOARDING_STEPS.TECH_COMFORT]: {
    titleKey: 'onboarding.questions.techComfort.title',
    subtitleKey: 'onboarding.questions.techComfort.subtitle',
    type: 'single-select',
    field: 'techComfort',
    options: ONBOARDING_OPTIONS.techComfort
  },
  
  [ONBOARDING_STEPS.CONTENT_TYPE]: {
    titleKey: 'onboarding.questions.contentType.title',
    subtitleKey: 'onboarding.questions.contentType.subtitle',
    type: 'single-select',
    field: 'contentType',
    options: ONBOARDING_OPTIONS.contentType
  },
  
  [ONBOARDING_STEPS.AUDIENCE_SIZE]: {
    titleKey: 'onboarding.questions.audienceSize.title',
    subtitleKey: 'onboarding.questions.audienceSize.subtitle',
    type: 'single-select',
    field: 'audienceSize',
    options: ONBOARDING_OPTIONS.audienceSize
  },
  
  [ONBOARDING_STEPS.LANGUAGE]: {
    titleKey: 'onboarding.questions.language.title',
    subtitleKey: 'onboarding.questions.language.subtitle',
    type: 'single-select',
    field: 'language',
    options: ONBOARDING_OPTIONS.language
  },
  
  [ONBOARDING_STEPS.INTERESTED_OVERLAYS]: {
    titleKey: 'onboarding.questions.interestedOverlays.title',
    subtitleKey: 'onboarding.questions.interestedOverlays.subtitle',
    type: 'multi-select',
    field: 'interestedOverlays',
    options: ONBOARDING_OPTIONS.interestedOverlays
  },
  
  [ONBOARDING_STEPS.MAIN_GOAL]: {
    titleKey: 'onboarding.questions.mainGoal.title',
    subtitleKey: 'onboarding.questions.mainGoal.subtitle',
    type: 'single-select',
    field: 'mainGoal',
    options: ONBOARDING_OPTIONS.mainGoal
  },
  
  [ONBOARDING_STEPS.BUDGET]: {
    titleKey: 'onboarding.questions.budget.title',
    subtitleKey: 'onboarding.questions.budget.subtitle',
    type: 'single-select',
    field: 'budget',
    options: ONBOARDING_OPTIONS.budget
  },
  
  [ONBOARDING_STEPS.HOW_DID_YOU_HEAR]: {
    titleKey: 'onboarding.questions.howDidYouHear.title',
    subtitleKey: 'onboarding.questions.howDidYouHear.subtitle',
    type: 'single-select',
    field: 'howDidYouHear',
    options: ONBOARDING_OPTIONS.howDidYouHear
  },
  
  [ONBOARDING_STEPS.SUGGESTIONS]: {
    titleKey: 'onboarding.questions.suggestions.title',
    subtitleKey: 'onboarding.questions.suggestions.subtitle',
    type: 'text',
    field: 'suggestions',
    placeholderKey: 'onboarding.questions.suggestions.placeholder'
  }
};

export const ONBOARDING_INITIAL_STATE = {
  completed: false,
  step: 0,
  platform: '',
  streamingExperience: '',
  overlayExperience: '',
  streamingSoftware: '',
  techComfort: '',
  contentType: '',
  audienceSize: '',
  language: '',
  interestedOverlays: [],
  mainGoal: '',
  budget: '',
  howDidYouHear: '',
  suggestions: '',
  completedAt: null
};